import { render, staticRenderFns } from "./ssq.vue?vue&type=template&id=736c0787&scoped=true"
import script from "./ssq.vue?vue&type=script&lang=js"
export * from "./ssq.vue?vue&type=script&lang=js"
import style0 from "./ssq.vue?vue&type=style&index=0&id=736c0787&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736c0787",
  null
  
)

export default component.exports